export const languageSwitch = {
  floatingLabel: 'Alterar idioma',
  arrowSwap: {
    alt: 'mudar linguagem'
  },
  flag: {
    alt: 'bandeira'
  }
};
